const YearlyBarsLinesChart = require('okCharts/YearlyBarsLinesChart');

module.exports = YearlyBarsLinesChart;
